import PropTypes from 'prop-types';
import { Fragment } from 'react';
import styled, { css } from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Link } from '@hivebrite/design-system/Link';

const isItemClickable = (tab) => !tab.active;
const hasDivider = (index, breadcrumbs) => index + 1 !== breadcrumbs.length;

export const BreadcrumbContent = ({
  tab,
  children,
  hasEllipsis = true,
  hasDivider = false,
}) => (
  <BreadcrumbWrapper hasEllipsis={hasEllipsis} hasDivider={hasDivider} {...tab}>
    {children}
  </BreadcrumbWrapper>
);

BreadcrumbContent.propTypes = {
  tab: PropTypes.object.isRequired,
  hasEllipsis: PropTypes.bool,
  hasDivider: PropTypes.bool,
};

/**
 * @deprecated please use `@hivebrite/design-system/Breadcrumb` instead
 */
const Breadcrumb = ({ breadcrumbs, divider = '>', hasUnderline = true }) => (
  <Box flexWrap="wrap">
    {breadcrumbs.map((tab, index) => (
      <Fragment key={tab.name}>
        <BreadcrumbContent
          tab={tab}
          hasDivider={hasDivider(index, breadcrumbs)}
        >
          {isItemClickable(tab) ? (
            <StyledLink
              to={tab.to}
              tabIndex={isItemClickable(tab) ? 0 : -1}
              hasUnderline={hasUnderline}
            >
              {tab.name}
            </StyledLink>
          ) : (
            tab.name
          )}
        </BreadcrumbContent>
        {hasDivider(index, breadcrumbs) && (
          <Box mx={2} font="h3-semibold">
            {divider}
          </Box>
        )}
      </Fragment>
    ))}
  </Box>
);

Breadcrumb.propTypes = {
  breadcrumbs: PropTypes.array.isRequired,
  divider: PropTypes.string,
  hasUnderline: PropTypes.bool,
};

export default Breadcrumb;

const BreadcrumbWrapper = styled(Box)
  .withConfig({
    shouldForwardProp: (prop) =>
      !['hasEllipsis', 'hasDivider', 'active'].includes(prop),
  })
  .attrs(({ hasEllipsis, hasDivider }) => ({
    display: 'block',
    font: 'h3-semibold',
    maxWidth: hasEllipsis && hasDivider && '20%',
    padding: '6px',
    margin: '-6px',
  }))`
  ${({ hasEllipsis }) =>
    hasEllipsis &&
    css`
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding-bottom: 1px;
    `}

`;

const StyledLink = styled(Link).withConfig({
  shouldForwardProp: (prop) => !['hasUnderline'].includes(prop),
})`
  ${({ hasUnderline }) =>
    !hasUnderline &&
    css`
      text-decoration: none;
      :hover {
        text-decoration: none;
      }
    `}
`;
